export { default, NoResultsProps } from "./NoResults";
